import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { GrClose } from "react-icons/gr";
import "../AppModal/ModalKit.css";

interface PropData {
    show: any;
    isClose: any;
    message: any;
}

const SucessModal = (props: PropData) => {
    const handleClose = () => {
        props.isClose();
    };

    return (
        <div>
            {props.show &&
                <Transition.Root show={!!props.show} as={Fragment}>
                    <Dialog as="div" className="relative z-[1050]" onClose={handleClose}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-[rgba(28,31,62,0.55)] transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-[1050] overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="fpm-panel fpm-sm">
                                        <button type="button" className="fpm-x" title="Close" onClick={handleClose}>
                                            <GrClose size={15} />
                                        </button>
                                        <div className="fpm-modal">
                                            <div className="fpm-head">
                                                <div className="fpm-badge fpm-badge-green">
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                                                </div>
                                                <Dialog.Title as="h2">Success</Dialog.Title>
                                            </div>
                                            <p className="fpm-msg">{props.message}</p>
                                            <div className="fpm-foot">
                                                <button
                                                    type="button"
                                                    className="fpm-btn-brand"
                                                    onClick={handleClose}
                                                >
                                                    Go back
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            }
        </div>
    );
};

export default SucessModal;
